function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import classes from './customer-mockup.scss';
class CustomerMockup extends React.Component {
  constructor(...args) {
    // @ts-ignore
    super(...args);
    _defineProperty(this, "imprintArea", void 0);
    _defineProperty(this, "logo", void 0);
    this.autoAdjustLogo = this.autoAdjustLogo.bind(this);
    this.state = {
      logoFullHeight: false,
      logoFullWidth: false
    };
  }
  autoAdjustLogo() {
    const {
      autoadjustLogo,
      logoSrc
    } = this.props;
    if (!autoadjustLogo || !logoSrc) {
      return;
    }
    const imprintAreaRatio = this.imprintArea.clientWidth / this.imprintArea.clientHeight;
    const logoRatio = this.logo.clientWidth / this.logo.clientHeight;
    if (imprintAreaRatio < logoRatio) {
      this.setState({
        logoFullWidth: true
      });
    } else {
      this.setState({
        logoFullHeight: true
      });
    }
  }
  render() {
    const {
      logoRect,
      logoSrc,
      image,
      className,
      imageWrapper,
      autoadjustLogo,
      innerWrapper,
      productImageWrapper,
      imageClassName,
      defaultWidth = 1,
      logoClassName,
      isLE,
      LEClassName
    } = this.props;
    const {
      logoFullHeight,
      logoFullWidth
    } = this.state;
    const styles = {};
    if (image && image.rectangle) {
      styles.rect = {
        top: `${image.rectangle.top}%`,
        left: `${image.rectangle.left}%`,
        width: `${image.rectangle.width}%`,
        height: `${image.rectangle.height}%`
      };
      styles.rect.backgroundImage = 'none';
    }
    if (logoRect && !autoadjustLogo) {
      styles.logoRect = {
        top: `${logoRect.top}%`,
        left: `${logoRect.left}%`,
        width: `${logoRect.width}%`,
        height: `${logoRect.height}%`
      };
    }
    styles.logoRect = _objectSpread({}, styles.logoRect, {
      width: styles.logoRect && `${styles.logoRect.width * defaultWidth}%` || `${100 * defaultWidth}%`
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.wrapper, className, imageWrapper)
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.inner, innerWrapper)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.relativeWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.rect, {
        [classes.hasCenteredContent]: autoadjustLogo
      }),
      style: styles.rect,
      ref: e => {
        this.imprintArea = e;
      }
    }, logoSrc && /*#__PURE__*/React.createElement("img", {
      style: styles.logoRect,
      ref: e => {
        this.logo = e;
      },
      className: classnames(classes.logoImg, logoClassName, {
        [classes.fullWidth]: logoFullWidth,
        [classes.fullHeight]: logoFullHeight
      }),
      src: logoSrc,
      alt: "Logo"
    })), /*#__PURE__*/React.createElement(Image, {
      isLE: isLE,
      LEClassName: LEClassName,
      onLoad: this.autoAdjustLogo,
      className: classnames(classes.img, imageClassName),
      wrapperClassName: productImageWrapper,
      src: image.url,
      alt: image.alt || 'Product image'
    }))));
  }
}
export default CustomerMockup;